var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.userSignatures,"loading":_vm.isLoading},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"success","data-cy":"ListUserSignature-button-new","to":{
          name: 'processing-EditUserSignature'
        }}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm.mdiPlus)+" ")]),_vm._v(" "+_vm._s(_vm.$t('common.buttons.new'))+" ")],1)],1)]},proxy:true},{key:"item.userId",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getEmailById(item.userId))+" ")]}},{key:"item.actions",fn:function(ref){
        var item = ref.item;
return [_c('TableBasicButtons',{attrs:{"editLink":{
        name: 'processing-EditUserSignature',
        query: {id: item.id}
      }},on:{"delete":function($event){return _vm.remove(item)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }